import type { LeaderboardEntry } from '../server/laps';
import type { LeaderboardHudRow } from './HUD';

export function buildHudLeaderboardRows(
  rows: LeaderboardEntry[],
  nearby: Array<LeaderboardEntry | null> = [],
): LeaderboardHudRow[] {
  if (rows.length === 0) return [];

  const record = rows[0];
  const out: LeaderboardHudRow[] = [{
    kind: 'record',
    rank: record.rank,
    handle: record.handle,
    totalMs: record.total_ms,
  }];

  if (nearby.length === 0) {
    out.push({
      kind: 'empty',
      rank: null,
      handle: 'No PB yet',
      totalMs: null,
    });
    return out;
  }

  const mine = nearby.find((row, index) => row !== null && index === 1) ?? null;
  const mineMs = mine?.total_ms ?? null;
  for (let i = 0; i < nearby.length; i++) {
    const row = nearby[i];
    if (!row) continue;
    const isMine = i === 1;
    const isDuplicateRecord = isMine
      && row.device_id === record.device_id
      && row.total_ms === record.total_ms;
    if (isDuplicateRecord) {
      out[0] = {
        kind: 'mine',
        rank: row.rank,
        handle: 'You / Record',
        totalMs: row.total_ms,
      };
      continue;
    }
    out.push({
      kind: isMine ? 'mine' : 'nearby',
      rank: row.rank,
      handle: isMine ? 'You' : row.handle,
      totalMs: row.total_ms,
      deltaMs: isMine || mineMs === null ? null : row.total_ms - mineMs,
    });
  }
  return out;
}
